import { GET } from '@/api';

const URL = '/account/registered-products/search';

export default async ({ term, sn, config, successCB, failCB }) => {
  const params = new URLSearchParams();
  if (term) params.append('term', term);
  if (sn) params.append('sn', sn);

  try {
    const { data } = await GET(`${URL}?${params.toString()}`, config);
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
